export enum RequestSource {
  ec = 'ECommerce',
  sna = 'StartNowApp',
}
